import { useQuery } from 'app/hooks/query';
import { useGuestService } from 'hooks/guest';
import { useUserService } from 'hooks/iam/user';
import React, { useEffect } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import { addDataToStore, updateDataToStore } from 'store/actions/user-data';

export const AuthRefresher = () => {
  const dispatch = useDispatch();
  const { token } = useQuery();
  const { refreshToken } = useGuestService();
  const { fetchUserData } = useUserService();
  const { id: user_id, tenant_id, permission_expires_at } = useSelector((state) => state.user_data);

  const [ticker, setTicker] = React.useState(0);

  useEffect(() => {
    if (!token) return;

    dispatch(updateDataToStore({ token }));
    window.location.href = window.location.href.replace(`?token=${token}`, '');
  }, [token]);

  useEffect(() => {
    fetchUserData().then(({ user }) => {
      if (!user) handleTokenRefresh(true);
    });

    handleTokenRefresh();
    const interval = setInterval(() => {
      setTicker((tick) => tick + 1);
    }, 60000);

    return () => {
      clearInterval(interval);
    };
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  useEffect(() => {
    handleTokenRefresh();
  }, [ticker]);

  const handleTokenRefresh = async (is_hard_refresh = false) => {
    const time_difference = permission_expires_at - Date.now();
    if (time_difference < 120000 || is_hard_refresh) {
      const refreshed_data = await refreshToken({ user_id, tenant_id });
      if (refreshed_data) {
        dispatch(addDataToStore(refreshed_data));
      }
    }
  };

  return <></>;
};
